import React, {useEffect, useState} from 'react';
import {
    CheckboxButton,
    DatePickerCustom,
    InputCuenta,
    InputEntidad,
    InputFormat,
    InputLista,
    Accordion,
    FormError,
    FormLabel
} from '../../../../components/common';
import DataTaggerFormRedux from '../../../../components/controls/DataTaggerFormRedux';
import DomiciliosGrid from '../../../../components/controls/DomiciliosGrid';
import DomiciliosComercioGrid from '../../../../components/controls/DomiciliosComercioGrid';
import RubrosComercioGrid from '../../../../components/controls/RubrosComercioGrid';
import VinculosComercioGrid from '../../../../components/controls/VinculosComercioGrid';
import { ALERT_TYPE, CUENTA_STATE, MASK_FORMAT, OPERATION_MODE, ShowToastMessage } from '@laramie/ui';
import {MakeListDomicilios} from '../../utils';
import {ElementosTab, TabsForm} from './components';
import InputSecret from '../../../../components/common/InputSecret';
import EspacioArrendadoGrid from '../../../../components/controls/EspacioArrendadoGrid';
import HabilitacionComercioGrid from '../../../../components/controls/HabilitacionComercioGrid';
import {usePermissions} from '../../../../components/hooks/usePermissions';
import {PERMISSIONS} from '../../../../consts/permissions';
import {TIPS} from "../../../../consts/tips";

const SectionForm = ({
                         SetTabActive,
                         setPendingChange,
                         state,
                         comercio_formValues,
                         comercio_formSet,
                         comercio_formHandleProxy,
                         cuenta_formValues,
                         cuenta_formHandleProxy,
                         UpdateEntity,
                         UpdateRubrosComercio,
                         zonaTarifariaInmueble,
                         FindZonaTarifariaInmueble,
                         handleClickBaja,
                         tipoArrendamiento,
                         setTipoArrendamiento,
                         errorOf,
                         comercioOpen,
                         setComercioOpen,
                         estadoOpen,
                         setEstadoOpen,
                         pendingChange,
                         refetchComercio
                     }) => {

    const [domicilios, setDomicilios] = useState([]);

    const {hasPermission} = usePermissions();
    const canEditPersonasVinculadas = hasPermission(PERMISSIONS.PERSONAS_VINCULADAS_EDIT);
    const canEditRubros = hasPermission(PERMISSIONS.RUBROS_EDIT);
    const canEditEspacioArrendado = hasPermission(PERMISSIONS.ESPACIO_ARRENDADO_EDIT);

    useEffect(() => {
        if (state.entity.zonasEntrega.length > 0 || state.entity.vinculosComercio.length > 0) {
            MakeListDomicilios(state)
                .then(response => {
                    setDomicilios(response);
                })
                .catch(error => {
                    const message = error.message;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setDomicilios([]);
                });
        } else {
            if (domicilios.length > 0) setDomicilios([]);
        }
    }, [state.entity.zonasEntrega, state.entity.vinculosComercio])

    return (
        <>
            <section className='section-accordion'>

                <div className="m-top-20 m-bottom-20">
                    <Accordion title="Cuenta" startOpen={true}>
                        <div className='row form-basic'>
                            <div className="col-12 col-md-3 col-lg-2">
                                <label htmlFor="cuenta_numeroCuenta" className="form-label">Número de cuenta</label>
                                <InputFormat
                                    name="cuenta_numeroCuenta"
                                    placeholder="[autonumérico]"
                                    className="form-control"
                                    mask={MASK_FORMAT.CUENTA}
                                    maskPlaceholder={null}
                                    value={cuenta_formValues.numeroCuenta}
                                    onChange={cuenta_formHandleProxy}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-6 col-md-4 col-lg-2">
                                <label htmlFor="cuenta_numeroWeb" className="form-label">Clave web</label>
                                <InputSecret
                                    name="cuenta_numeroWeb"
                                    mask={MASK_FORMAT.CLAVE_WEB}
                                    maskPlaceholder={null}
                                    value={cuenta_formValues.numeroWeb}
                                    onChange={cuenta_formHandleProxy}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                />
                            </div>
                            {(state.mode !== OPERATION_MODE.NEW) && (
                                <>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_idEstadoCuenta" className="form-label">Estado de
                                            cuenta</label>
                                        <InputLista
                                            name="cuenta_idEstadoCuenta"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.idEstadoCuenta}
                                            disabled={true}
                                            lista="EstadoCuenta"
                                        />
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_fechaAlta" className="form-label">Fecha alta</label>
                                        <DatePickerCustom
                                            name="cuenta_fechaAlta"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.fechaAlta}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_fechaBaja" className="form-label">Fecha baja</label>
                                        <DatePickerCustom
                                            name="cuenta_fechaBaja"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.fechaBaja}
                                            disabled={true}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </Accordion>

                    {(state.mode !== OPERATION_MODE.NEW) && (
                        <>
                            <div className="m-top-20">
                                <Accordion title="Personas vinculadas">
                                    <VinculosComercioGrid
                                        processKey={state.processKey}
                                        disabled={state.mode === OPERATION_MODE.VIEW || !canEditPersonasVinculadas}
                                        data={{
                                            idComercio: state.id,
                                            list: state.entity.vinculosComercio
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Domicilios">
                                    <DomiciliosGrid
                                        data={{
                                            list: domicilios
                                        }}
                                    />
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Domicilio del Comercio">
                                    <DomiciliosComercioGrid
                                        processKey={state.processKey}
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                        data={{
                                            idComercio: state.entity.comercio.id,
                                            domicilioComercio: state.entity.domicilioComercio
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Datos del comercio" open={comercioOpen} onToggle={setComercioOpen}>
                                    <div className='row form-basic'>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 ">
                                            <label htmlFor="comercio_idCuentaInmueble" className="form-label">Cuenta
                                                inmueble</label>
                                            <InputCuenta
                                                name="comercio_idCuentaInmueble"
                                                placeholder=""
                                                className="form-control"
                                                value={comercio_formValues.idCuentaInmueble}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                onChange={(event) => {
                                                    const idInmueble = (event.target.row) ? event.target.row.id : 0;
                                                    comercio_formSet({
                                                        ...comercio_formValues,
                                                        idCuentaInmueble: idInmueble
                                                    });
                                                    if (idInmueble > 0) FindZonaTarifariaInmueble(idInmueble);
                                                    setPendingChange(true);
                                                }}
                                                idTipoTributo={10}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-2 ">
                                            <label htmlFor="zonaTarifariaInmueble" className="form-label">Zona tarifaria
                                                inmueble</label>
                                            <input
                                                name="zonaTarifariaInmueble"
                                                type="text"
                                                className="form-control"
                                                value={zonaTarifariaInmueble.valor}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-2 ">
                                            <FormLabel htmlFor="comercio_numeroCuit" required={state.mode === OPERATION_MODE.EDIT}>CUIT</FormLabel>
                                            <InputFormat
                                                name="comercio_numeroCuit"
                                                placeholder=""
                                                className={`form-control ${errorOf('numeroCuit') ? 'is-invalid' : ''}`}
                                                mask={MASK_FORMAT.CUIT}
                                                maskPlaceholder={null}
                                                value={comercio_formValues.numeroCuit}
                                                onChange={(event) => {
                                                    event.target.value = event.target.value.replaceAll('-', '');
                                                    comercio_formHandleProxy(event)
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                            <FormError message={errorOf('numeroCuit')} />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-2 ">
                                            <label htmlFor="digitoVerificador" className="form-label">Dígito
                                                verificador</label>
                                            <input
                                                name="digitoVerificador"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                autoComplete="off"
                                                value={comercio_formValues.digitoVerificador}
                                                onChange={comercio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                            <FormError />
                                        </div>
                                        {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3 align-self-end">
                                            <CheckboxButton
                                                name="granContribuyente"
                                                label="Gran contribuyente"
                                                checked={comercio_formValues.granContribuyente}
                                                onChange={comercio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                        </div>*/}
                                    </div>
                                    <div className='row form-basic'>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                            <label htmlFor="comercio_idTipoUbicacion" className="form-label">Tipo
                                                ubicación</label>
                                            <InputEntidad
                                                name="comercio_idTipoUbicacion"
                                                placeholder=""
                                                tipName={TIPS.NAME.MODALS.TIPO_UBICACION_MODAL}
                                                className="form-control"
                                                value={comercio_formValues.idTipoUbicacion}
                                                onChange={comercio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                title="Tipo ubicación"
                                                entidad="TipoUbicacion"
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-4 ">
                                            <label htmlFor="comercio_nombreFantasia" className="form-label">Nombre de
                                                fantasía</label>
                                            <input
                                                name="comercio_nombreFantasia"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                autoComplete="off"
                                                value={comercio_formValues.nombreFantasia}
                                                onChange={comercio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-5 ">
                                            <FormLabel htmlFor="comercio_razonSocial" required={state.mode === OPERATION_MODE.EDIT}>Razón social</FormLabel>
                                            <input
                                                name="comercio_razonSocial"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('razonSocial') ? 'is-invalid' : ''}`}
                                                autoComplete="off"
                                                value={comercio_formValues.razonSocial}
                                                onChange={comercio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                            <FormError message={errorOf('razonSocial')} />
                                        </div>
                                    </div>
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Habilitaciones">
                                    <HabilitacionComercioGrid
                                        processKey={state.processKey}
                                        data={{
                                            idComercio: state.entity.comercio.id,
                                            list: state.entity.habilitacionesComercio
                                        }}
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </Accordion>
                            </div>

                            {(comercio_formValues.idTipoUbicacion > 1 && //no general
                                <div className="m-top-20">
                                    <Accordion title="Mercado de frutos / Estación fluvial">
                                        <EspacioArrendadoGrid
                                            processKey={state.processKey}
                                            data={{
                                                idComercio: state.entity.comercio.id,
                                                list: state.entity.espaciosArrendado
                                            }}
                                            disabled={!canEditEspacioArrendado}
                                            onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                        />
                                    </Accordion>
                                </div>
                            )}

                            <div className="m-top-20">
                                <Accordion title="Rubros">
                                    <RubrosComercioGrid
                                        processKey={state.processKey}
                                        disabled={state.mode === OPERATION_MODE.VIEW || !canEditRubros}
                                        data={{
                                            idComercio: state.entity.comercio.id,
                                            idCuenta: state.entity.cuenta.id,
                                            list: state.entity.rubrosComercio
                                        }}
                                        onChange={(typeEntity, rows) => UpdateRubrosComercio(rows)}
                                    />
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Estado" open={estadoOpen} onToggle={setEstadoOpen}>
                                    <div className='row form-basic'>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <FormLabel htmlFor="comercio_idEstadoCarga" required>Estado de carga</FormLabel>
                                            <InputLista
                                                name="comercio_idEstadoCarga"
                                                placeholder=""
                                                className={`form-control ${errorOf('idEstadoCarga') ? 'is-invalid' : ''}`}
                                                value={comercio_formValues.idEstadoCarga}
                                                onChange={comercio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW || state.entity.comercio.idEstadoCarga !== 20}
                                                lista="EstadoCarga"
                                            />
                                            <FormError message={errorOf('idEstadoCarga')} />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <label htmlFor="comercio_fechaCargaInicio" className="form-label">Fecha
                                                inicio carga</label>
                                            <DatePickerCustom
                                                name="comercio_fechaCargaInicio"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.comercio.fechaCargaInicio}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <label htmlFor="comercio_fechaCargaFin" className="form-label">Fecha fin
                                                carga</label>
                                            <DatePickerCustom
                                                name="comercio_fechaCargaFin"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.comercio.fechaCargaFin}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-6">
                                            {state.mode === OPERATION_MODE.EDIT && state.entity.cuenta.idEstadoCuenta === CUENTA_STATE.ACTIVA &&
                                                <button className="btn action-button float-end m-top-30"
                                                        onClick={(event) => handleClickBaja()}>Baja</button>
                                            }
                                        </div>
                                    </div>
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Elementos">
                                    <ElementosTab {...{state, UpdateEntity}} />
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Información adicional">
                                    <DataTaggerFormRedux
                                        title="Información adicional de Comercio"
                                        processKey={state.processKey}
                                        entidad="Comercio"
                                        idEntidad={state.id}
                                        disabled={(state.mode === OPERATION_MODE.VIEW)}
                                        onChange={(row) => setPendingChange(true)}
                                    />
                                </Accordion>
                            </div>

                            <TabsForm
                                state={state}
                                SetTabActive={SetTabActive}
                                UpdateEntity={UpdateEntity}
                                pendingChange={pendingChange}
                                refetchComercio={refetchComercio}
                            />
                        </>
                    )}

                </div>

            </section>
        </>
    )
}
export default SectionForm

